__turbopack_context__.v({
  "className": "inter_50a9b395-module__23eDUG__className",
  "variable": "inter_50a9b395-module__23eDUG__variable",
});
